import FilterItem from "../../components/reuseComp/FilterSection";
import { useEffect, useState } from "react";

export const DocumentFilterMenu = ({
  selectedFilters,
  setSelectedFilters,
  refetch,
}: {
  selectedFilters: Record<string, string>;
  setSelectedFilters: (v: any) => void;
  refetch: (data: any) => void;
}) => {
  const [openKey, setOpenKey] = useState<string | null>(null);

  const toggle = (key: string) => {
    setOpenKey((prev) => (prev === key ? null : key));
  };

  const setFilter = (key: string, value: string) => {
    setSelectedFilters((prev: any) => ({
      ...prev,
      [key]: value, // overwrite previous selection
    }));
  };

  useEffect(() => {
    if (!selectedFilters || Object.keys(selectedFilters).length === 0) return;
    refetch(selectedFilters);
  }, [selectedFilters]);

  return (
    <div className="w-60 p-4 rounded-xl bg-[#F7E4D4] custom_shadow">
      {/* <FilterItem
        label="Dates"
        keyName="date"
        selectedValue={selectedFilters.date}
        isOpen={openKey === "date"}
        onClick={() => toggle("date")}
        options={["Today", "Yesterday"]}
        onSelect={setFilter}
      /> */}

      <FilterItem
        label="Status"
        keyName="status"
        selectedValue={selectedFilters.status}
        isOpen={openKey === "status"}
        onClick={() => toggle("status")}
        options={["PENDING", "REJECT", "REQUIRE_CORRECTION", "APPROVED"]}
        onSelect={setFilter}
      />
    </div>
  );
};


